export default {
  // 页面标题和描述
  title: "Discover the best Aha experience for your business",
  description: "Provide a few details, and we’ll align our services with your unique business goals and scenario",
  
  // 表单字段标签
  formLabels: {
    name: "Name",
    firstName: "First name",
    lastName: "Last name",
    email: "Work email",
    website: "Company website (URL)",
    budget: "What's your monthly influencer marketing budget",
    industry: "What's your industry",
    goal: "What's your campaign goal",
    location: "Where is your organization located?",
    phone: "Phone number",
    wechat: "WeChat",
    contact: "Contact information",
    linkedin: "LinkedIn",
    note: "Anything that will help prepare for our meeting (optional)"
  },
  
  // 表单占位符
  placeholders: {
    name: "Enter your full name",
    firstName: "e.g. Alex",
    lastName: "e.g. Johnson",
    email: "e.g. alex.johnson@company.com",
    website: "e.g. www.yourcompany.com",
    budget: "Select a budget range",
    industry: "Select your industry",
    goal: "Select a campaign goal",
    country: "Select your country or region",
    phone: "Enter your phone number",
    code: "Code",
    wechat: "Enter your WeChat account",
    contact: "LinkedIn / WhatsApp / Line / Telegram / Slack",
    linkedin: "Enter your LinkedIn Profile URL",
    note: "Anything you'd like us to know…"
  },
  
  // 表单验证消息
  validation: {
    nameRequired: "Please input your name",
    firstNameRequired: "Please input your first name",
    lastNameRequired: "Please input your last name",
    emailRequired: "Please input your work email",
    emailInvalid: "Please input a valid work email",
    websiteRequired: "Please input your company website",
    websiteInvalid: "Please enter a valid website URL",
    budgetRequired: "Please select your marketing budget",
    budgetTooLow: "Aha is designed for budgets of USD 2,000 or more. We'll reach out as soon as Aha Lite supports smaller budgets.",
    industryRequired: "Please input your first name",
    goalRequired: "Please input your last name",
    countryRequired: "Please select Your Country or Region",
    phoneRequired: "Please enter your phone number",
    phoneInvalid: "Invalid phone number",
    codeRequired: "Please enter verification code",
    codeLength: "Verification code must be 6 digits",
    codeIncorrect: "Please enter the correct verification code",
    wechatRequired: "Please enter your WeChat account",
    contactRequired: "Please enter your contact information"
  },
  
  // 按钮文本
  buttons: {
    sendCode: "Send verification code",
    resend: "Resend",
    resendCountdown: "Resend {countdown}s",
    submit: "Submit",
    chooseDateTime: "Choose a date & time",
    loading: "loading...",
    continue: "Continue",
  },
  
  // 其他文本
  required: "*",
  source: "platform",
  
  // 预算选项
  budgetOptions: {
    lessThan2000: "Less than 2,000 USD / mo",
    "2000To10000": "2,000 - 10,000 USD / mo",
    "10000To50000": "10,000 - 50,000 USD / mo",
    moreThan50000: "More than 50,000 USD / mo"
  },
  
  // 行业选项
  industryOptions: {
    aiSaaSApp: "AI / SaaS / App",
    ecommerce: "Ecommerce",
    agency: "Agency – AI/SaaS/App/Ecommerce focus",
    beauty: "Beauty",
    foodBeverage: "Food & beverage",
    others: "Others"
  },
  
  // 活动目标选项
  campaignGoalOptions: {
    brandAwareness: "Brand awareness",
    brandAwarenessAndPerformance: "Brand awareness and performance",
    performanceOnly: "Direct Sales (Not applicable for Aha)"
  }
};
